






import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import { msgTip } from '@/utils/urlUtils'
import { AButton } from '../../components'
import mainTemplate from '@/components/MainTemplate.vue'
import Main from './components/Main.vue'

@Component({
  components: {
    mainTemplate,
    Main
  }
})
export default class Auto extends Vue {
  // token
  public get token() {
    return this.$route.query.token || null
  }
  // style
  public get style() {
    return this.$route.query.style || null
  }
}
